@let userRoles = userRoles$ | async;
@let notificationCountUnread = notificationCountUnread$ | async;
@let communicationChartCountUnread = commentsUnreadCount$ | async;
@let isOpenSidebarMenu = isOpenSidebarMenu$ | async;
@let isOpenMobileMenu = isOpenMobileMenu$ | async;

<div class="header">
  <div class="header__left-side">
    <button
      (click)="
        isMobile
          ? toggleMobileMenu(isOpenMobileMenu!)
          : toggleSidebarMenu(isOpenSidebarMenu!)
      "
      class="menu"
      mat-icon-button>
      <img
        [src]="
          (isOpenSidebarMenu && !isMobile) || (!isOpenMobileMenu && isMobile)
            ? 'assets/svg/menu.svg'
            : 'assets/svg/close.svg'
        "
        [alt]="
          (isOpenSidebarMenu && !isMobile) || (isOpenMobileMenu && isMobile)
            ? 'Menu'
            : 'Close'
        " />
    </button>
    <img class="logo" src="assets/svg/logo.svg" alt="logo" />
  </div>
  <div class="header__right-side">
    @if (oAuthService.hasValidAccessToken()) {
      @if (
        userRoles?.includes(RoleName.Buyer) ||
        userRoles?.includes(RoleName.Admin)
      ) {
        <button
          mat-button
          class="header__create-button"
          [matMenuTriggerFor]="createMenu">
          <img src="assets/svg/plusWhite.svg" alt="plus" />{{
            'CREATE' | translate
          }}
        </button>
      }

      <img class="header-iconBtn" src="assets/svg/ai.svg" alt="Ai" />
      <button class="messages" (click)="openMessagePanel()">
        <img
          class="header-iconBtn"
          src="assets/svg/messages.svg"
          alt="Messages" />
        @if (
          communicationChartCountUnread?.newMessageNotificationsCount !== 0
        ) {
          <p class="messages_count">
            {{ communicationChartCountUnread?.newMessageNotificationsCount }}
          </p>
        }
      </button>

      <button
        class="notification"
        mat-icon-button
        (click)="openNotificationPanel()"
        [ngClass]="{ active: isOpenNotificationPanel }">
        <img class="header-iconBtn" src="assets/svg/bell.svg" alt="Bell" />
        @if (notificationCountUnread) {
          <p class="notification_count">{{ notificationCountUnread }}</p>
        }
      </button>
      <app-user-popup-menu></app-user-popup-menu>
    } @else {
      <button (click)="navigateOnSomePage('/signin')" mat-stroked-button>
        {{ 'LOG_IN' | translate }}
      </button>
      <button
        (click)="navigateOnSomePage('/signup')"
        mat-button
        class="header__create-button">
        {{ 'SIGN_UP' | translate }}
      </button>
    }
  </div>
</div>

<mat-menu #createMenu>
  @for (item of dropdownItems; track item.type) {
    @if (!item.requiredRole || userRoles?.includes(item.requiredRole)) {
      <div (click)="selectItem(item.type)" mat-menu-item>
        <div class="create-menu-item">
          <img [src]="'assets/svg/' + item.icon" [alt]="item.type" />
          <span>{{ item.type | uppercase | translate }}</span>
        </div>
      </div>
    }
  }
</mat-menu>

<app-notification-panel
  [ngClass]="{ open: isOpenNotificationPanel }"
  (closePanel)="isOpenNotificationPanel = false"></app-notification-panel>

<app-communication-chart-panel
  [ngClass]="{ open: isOpenMessagePanel }"
  (closePanel)="closeCommunicationChartPanel()"></app-communication-chart-panel>
